import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { CDN_URLS } from '../../config/cdn';
import BlogCard from './BlogCard';
import './BlogPage.css';

// Mock blog data - in a real app, this would come from an API
export const mockBlogPosts = [
  {
    id: 13,
    title: 'OpenClaw vs MemU: Which AI Memory Layer Should You Choose?',
    excerpt: 'AI agents are getting smarter — but without persistent memory, they forget everything when a session ends. OpenClaw and MemU tackle this from very different angles. Here\'s a deep-dive comparison to help you choose.',
    date: 'Feb 22',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20251202-182300.png',
    category: 'featured',
    slug: 'openclaw-vs-memu',
    metaDescription: 'A detailed comparison of OpenClaw and MemU — two open-source projects approaching AI memory from different angles. Learn which one fits your use case.',
  },
  {
    id: 12,
    title: 'Turning Logs into Agent Memory & Skills',
    excerpt: 'In modern automation pipelines, logs are far more than a record of “what happened.”If logs can be interpreted, structured, distilled, and transformed into reusable knowledge, every failed or successful deployment becomes fuel for the next flawless release.',
    date: 'Dec 2',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20251202-182300.png',
    category: 'featured',
    slug: 'turning-logs-into-agent-memory-and-skills',
    metaDescription: 'In modern automation pipelines, logs are far more than a record of “what happened.”If logs can be interpreted, structured, distilled, and transformed into reusable knowledge, every failed or successful deployment becomes fuel for the next flawless release.',
  },
  {
    id: 11,
    title: 'Build a Real-Time Voice Agent with Memory',
    excerpt: 'In this tutorial, you’ll build a real-time voice agent with memory, powered by TEN Framework and memU, that remembers your name, preferences, and past conversations.',
    date: 'Dec 2',
    authors: [
      {
        name: 'TEN Framework',
        avatar: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20251202-174519.png',
      },
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      },
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20251202-174728.png',
    category: 'tutorial',
    slug: 'build-real-time-voice-agent',
    metaDescription: 'Build a real-time voice agent with memory, powered by TEN Framework and memU, that remembers your name, preferences, and past conversations.',
  },
  {
    id: 10,
    title: 'Turn Your Daily Chaos into Long-Term AI Memory',
    excerpt: 'One day I was chatting with ChatGPT about my work. I told it I’m a backend developer, and I recently started contributing code to a Python CLI tool. I also said I want to build a tool for API testing and docs management, and I will start a prototype in the next few months. Another time, I suddenly wanted to visit San Francisco. When I told ChatGPT, it started asking what I like. I said food and nature, and I also want to visit some tech companies. My partner likes photography and museums. Then we talked about Muir Woods, vegan restaurants, morning running routes… Later, because I’m in charge of a big product launch next month, I got very stressed and couldn’t sleep. When ChatGPT heard that, it started talking with me about ways to relax, sleep habits, and how to set boundaries between work and life.',
    date: 'Nov 27',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20251127-185656.png',
    category: 'featured',
    slug: 'turn-your-daily-chaos-into-long-term-ai-memory',
    metaDescription: 'Turn your messy daily chats into long-term AI memory. See use cases showing how memU organizes ideas, tracks goals, and helps you revisit habits easily.',
  },
  {
    id: 9,
    title: 'From Reactive to Proactive: How Memory Gives AI a Sense of Agency',
    excerpt: 'Over the past few years, AI has been all about understanding and generation. Models have become better at language, better at writing, and even better at art. But a deeper question has emerged: If AI can only respond, it remains passive. If AI can think proactively, it becomes a true assistant.',
    date: 'Oct 23',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20251023_184701.png',
    category: 'featured',
    slug: 'proactive-ai-with-memory',
    metaDescription: '',
  },
  {
    id: 8,
    title: 'MemU Joins Hacktoberfest 2025 🎉',
    excerpt: 'Hacktoberfest is here again — the global celebration of open source! We’re excited that memU is joining this year and ready to welcome new contributors. Come join Hacktoberfest and memU, and let’s collaboratively build smarter AI agents with long‑term memory through open source.',
    date: 'Oct 16',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20251016-230159.png',
    category: 'community',
    slug: 'memu-joins-hacktoberfest-2025',
    metaDescription: '',
  },
  {
    id: 7,
    title: 'Introducing MemU Response API: The World\'s First Unified API with Built-in Long-Term Memory',
    excerpt: 'One call = Response + Memory. Discover the groundbreaking solution that makes AI truly remember every interaction without requiring you to re-architect your entire system.',
    date: 'Oct 1',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20250930-01.png',
    category: 'featured',
    slug: 'response-api-launch',
    metaDescription: '',
  },
  // {
  //   id: 6,
  //   title: 'The Agentic Memory Revolution: How Autonomous Agents Are Transforming AI Memory Systems',
  //   excerpt: 'Discover how agentic memory systems powered by autonomous agents are revolutionizing AI applications with intelligent memory management, organization, and evolution.',
  //   date: 'Sep 17',
  //   authorAvatar: CDN_URLS.logo,
  //   author: 'MemU Team',
  //   image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/agentic-memory-banner.png',
  //   category: 'featured',
  //   slug: 'agentic-memory-revolution'
  // },
  {
    id: 5,
    title: 'Empower AI Memory, shape the future —— be a memU Ambassador',
    excerpt: 'Ever felt that AI interactions could be so much more? That with true AI Memory, they could truly understand us? You\'re not alone. We believe the future of AI is personal, contextual, and profound, but we can\'t build it alone. ✨',
    date: 'Sep 2',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20250902-232944.png',
    category: 'community',
    slug: 'be-a-memu-ambassador', // Add slug for routing
    metaDescription: '',
  },
  {
    id: 4,
    title: 'MemU Best Practice Guide',
    excerpt: 'Master the art of implementing short-term and long-term memory systems for your LLM agents. This comprehensive guide covers best practices, implementation patterns, and optimization strategies for the MemU memory management system.',
    date: 'Aug 10',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/202508101623.png',
    category: 'programming',
    slug: 'memu-best-practice', // Add slug for routing
    metaDescription: '',
  },
  {
    id: 3,
    title: 'MemU SDK Guide - Cloud Version Documentation',
    excerpt: 'Before reading this article, please refer to our documentation for definitions of key terms used in MemU.',
    date: 'Aug 8',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro/image/20250810-005931.png',
    category: 'programming',
    slug: 'memu-sdk-guide', // Add slug for routing
    metaDescription: '',
  },
  {
    id: 2,
    title: 'Understanding MemU: Core Concepts and Terms',
    excerpt: 'With MemU, you can build AI applications that truly remember their users. They learn preferences, context, and patterns, growing smarter with every interaction.',
    date: 'Aug 8',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: CDN_URLS.workflow,
    category: 'featured',
    slug: 'understanding-memu', // Add slug for routing
    metaDescription: '',
  },
  {
    id: 1,
    title: 'MemU: Let AI Truly Memorize You',
    excerpt: 'Current AI memory solutions face scalability challenges. They rely on explicit modeling — manually telling the system which memories matter and which don\'t.',
    date: 'Aug 7',
    authors: [
      {
        name: 'MemU Team',
        avatar: CDN_URLS.logo,
      }
    ],
    image: CDN_URLS.banner,
    category: 'featured',
    slug: 'memu-introduction', // Add slug for routing
    metaDescription: '',
  }
];

const BlogPage = () => {
  const navigate = useNavigate();
  const [blogPosts] = useState(mockBlogPosts);
  const [loading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Show/hide scroll to top button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  // Extract unique categories from blog posts
  const uniqueCategories = [...new Set(blogPosts.map(post => post.category))];
  const categories = [
    'All',
    ...uniqueCategories.map(category => 
      category.charAt(0).toUpperCase() + category.slice(1)
    )
  ];

  // Filter posts based on selected category
  const filteredPosts = selectedCategory === 'all'
    ? blogPosts // Show all posts for "For you" and "Following"
    : blogPosts.filter(post => post.category === selectedCategory);

  const handleBlogClick = (post) => {
    if (post.url && !post.isInternal) {
      window.open(post.url, '_blank', 'noopener noreferrer');
    } else if (post.slug) {
      // Navigate to internal blog detail page using slug
      navigate(`/blog/${post.slug}`);
    } else {
      // For posts without slug, log for debugging
      console.log('No slug found for post:', post.id);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category === 'All' ? 'all' : category.toLowerCase());
  };

  if (loading) {
    return (
      <main>
        <div className="blog-page-container">
          <div className="blog-page-header">
            <div className="section-header">
              <h1>MemU Blog</h1>
              <p>Insights, updates, and stories from the MemU team</p>
            </div>
          </div>
          <div className="blog-page-loading">
            <div className="blog-page-loading-spinner"></div>
            <p>Loading articles...</p>
          </div>
        </div>
      </main>
    );
  }

  return (
    <>
      <Helmet>
        <title>MemU Blog - Insights, Updates & Stories from AI Memory Experts</title>
        <meta name="description" content="Discover insights about agentic memory systems, autonomous agents, and AI memory management from the MemU team. Learn about best practices, implementation guides, and the latest developments in agentic memory layer technology for LLM applications." />
        <meta name="keywords" content="agentic memory blog, autonomous agents, AI memory systems, memory management insights, llm memory guide, agentic architecture, autonomous memory management, intelligent memory systems, ai application blog, memory layer updates, artificial intelligence blog, chatbot memory, memory evolution, self-organizing memory" />
        
        {/* Open Graph */}
        <meta property="og:title" content="MemU Blog - Insights, Updates & Stories from AI Memory Experts" />
        <meta property="og:description" content="Discover insights, updates, and stories from the MemU team. Learn about AI memory best practices, implementation guides, and the latest developments in memory layer technology." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://memu.pro/blog" />
        <meta property="og:image" content="https://d192tm8h0ep0ud.cloudfront.net/memu.pro/static/memu-logo.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MemU Blog - Insights, Updates & Stories from AI Memory Experts" />
        <meta name="twitter:description" content="Discover insights, updates, and stories from the MemU team. Learn about AI memory best practices, implementation guides, and the latest developments in memory layer technology." />
        <meta name="twitter:image" content="https://d192tm8h0ep0ud.cloudfront.net/memu.pro/static/memu-logo.png" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "MemU Blog",
            "description": "Insights, updates, and stories about AI memory layer technology",
            "url": "https://memu.pro/blog",
            "publisher": {
              "@type": "Organization",
              "name": "MemU Team",
              "logo": {
                "@type": "ImageObject",
                "url": "https://d192tm8h0ep0ud.cloudfront.net/memu.pro/static/logo.png"
              }
            },
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://memu.pro/blog"
            }
          })}
        </script>
      </Helmet>
      
      <main>
      <div className="blog-page-container">
        <div className="blog-page-header">
          <div className="section-header">
            <h1>MemU Blog</h1>
            <p>Insights, updates, and stories from the MemU team</p>
          </div>

          <div className="blog-page-categories">
            {categories.map(category => (
              <button
                key={category}
                className={`blog-page-category-btn ${selectedCategory === (category === 'All' ? 'all' : category.toLowerCase()) ? 'active' : ''}`}
                onClick={() => handleCategoryChange(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="blog-page-content">
          {filteredPosts.length === 0 ? (
            <div className="blog-page-no-posts">
              <h3>No posts found</h3>
              <p>There are no posts in the selected category yet.</p>
            </div>
          ) : (
            <div className="blog-page-list">
              {filteredPosts.map((post) => (
                <BlogCard
                  key={post.id}
                  post={post}
                  onClick={handleBlogClick}
                  isFeatured={false}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Scroll to top button */}
      {showScrollTop && (
        <button
          className="blog-page-scroll-to-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 15L12 9L6 15" />
          </svg>
        </button>
      )}
    </main>
    </>
  );
};

export default BlogPage;
